
import { useNavigate } from 'react-router-dom';

import '../styles/EmployeeMaster.css';
import MainDeptTable from '../components/MainDeptTable';

const MainDept = () => {
  const navigate = useNavigate();

  const handleAddClick = () => {
    
    navigate('/maindept/add');
  };

  

  return (
    <div className="employee-master-page">
      <div className="employee-header">
        <h2>Main Dept Master</h2>
        <button className="add-employee-btn" onClick={handleAddClick}>
          Add Main Dept
        </button>
      </div>

      <MainDeptTable />
    </div>
  );
};

export default MainDept